export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ввод:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Продолжить"])}
}